import _ from "lodash";
import React, { useEffect, useRef, useState } from "react";
import {
  ArticleData,
  OrderType,
} from "../../../_App/Types/Entites/Orders/OrderType";
import { Modal } from "react-bootstrap";
import { useAppDispatch, useAppSelector } from "../../../_App/Redux/hooks";
import {
  getOrderByIdApi,
  resetRetrievedOrder,
} from "../../../_App/Redux/Slices/Orders/OrderSlice";
import {
  selectUser,
  societeId,
} from "../../../_App/Redux/Slices/Auth/authSlice";
import {
  findsocieteinfoApi,
  findSocieteLivraison,
  SocieteLivraison,
} from "../../../_App/Redux/Slices/societe/societeSlice";
import SocieteType from "../../../_App/Types/Entites/SocieteType";
import { numberToWords } from "../../../_App/Helpers/helpers";
import Loader from "../../../_Layouts/Loader/Loader";
import { Panier } from "../../../_App/Redux/Slices/Caisse/PanierSlice";
import {
  findTicketsByOrderApi,
  getTicketById,
} from "../../../_App/Redux/Slices/tickets/TicketSlice";
import { findPaymentsByTicketApi } from "../../../_App/Redux/Slices/payments/PaymentSlice";
import { getBonByEchangeOrder } from "../../../_App/Redux/Slices/reduction/reductionSlice";
import TicketType from "../../../_App/Types/Entites/TicketType";
import { t } from "i18next";
import { ISO_8601 } from "moment";

const OnlineOrderInvoice = ({
  order_id,
  show,
  setShow,
  onClose,
  type,
  ticket,
  orderstype,
}: any) => {
  const dispatch = useAppDispatch();
  const [order, setOrder] = useState<OrderType | null>(null);
  const cart = useAppSelector(Panier);
  const societe_id = useAppSelector(societeId);
  const invoiceRef = useRef<HTMLDivElement>(null); // Reference for the invoice section
  const [ste, setste] = useState<SocieteType | null>(null);
  const [loading, setLoading] = useState(false); // Loading state
  const user = useAppSelector(selectUser);
  const livraison = useAppSelector(SocieteLivraison);
  const [ticketData, setTicketData] = useState<TicketType | undefined>(
    undefined,
  );
  const [data, setData] = useState<any>(undefined);
  const [payments, setPayments] = useState<any[]>([]);
  const paymentDetails = React.useMemo(
    () => _.groupBy(payments, "payment_method"),
    [payments],
  );
  const totalPaid = Object.values(paymentDetails || {}).reduce(
    (sum: number, list: any) =>
      sum + list.reduce((s: number, p: any) => s + (Number(p.amount) || 0), 0),
    0,
  );
  useEffect(() => {
    const fetchData = async () => {
      if (order_id && societe_id) {
        setLoading(true); // Set loading to true before fetching data
        try {
          const res = await dispatch(getOrderByIdApi(order_id));
          if (res.payload && res.payload._id) {
            setOrder(res.payload);
          }
          if (ticket) {
            const resT = await dispatch(
              getTicketById({ id: ticket, order: undefined }),
            );
            if (resT.payload && resT.payload._id) {
              setTicketData(resT.payload);
            }
          }

          const res1 = await dispatch(findsocieteinfoApi(societe_id));
          const res2 = await dispatch(findSocieteLivraison(societe_id));

          if (res1.payload && res1.payload._id) {
            setste(res1.payload);
          }

          const ticketsRes: any = await dispatch(
            findTicketsByOrderApi(order_id),
          );
          const tickets = Array.isArray(ticketsRes.payload)
            ? ticketsRes.payload
            : [];
          const paymentsPerTicket = await Promise.all(
            tickets.map((tk: any) =>
              dispatch(findPaymentsByTicketApi(tk._id)),
            ),
          );
          const allPayments = paymentsPerTicket
            .filter((r: any) => Array.isArray(r.payload))
            .flatMap((r: any) => r.payload);
          setPayments(allPayments);
        } catch (error) {
          console.error("Échec de la récupération de la commande:", error);
        } finally {
          setLoading(false); // Set loading to false after fetching data
        }
      }
    };

    fetchData();
  }, [dispatch, order_id, societe_id]);

  useEffect(() => {
    if (!show) {
      setOrder(null); // Clear order on modal hide
      setPayments([]);
      dispatch(resetRetrievedOrder());
    }
  }, [show]);

  useEffect(() => {
    setData(
      ticket ? ticketData?.ticket_order : type === "Echange" ? cart : order,
    );
  }, [show, ticket, order, ticketData]);

  const handlePrint = () => {
    if (invoiceRef.current) {
      const printContent = invoiceRef.current.innerHTML;
      const originalContent = document.body.innerHTML;

      document.body.innerHTML = printContent; // Temporarily replace the entire page content with the invoice
      window.print(); // Trigger print
      document.body.innerHTML = originalContent; // Restore original content after printing
      window.location.reload(); // Refresh to ensure the page returns to its previous state
    }
  };
  const calculateTotalHT = () => {
    if (!Array.isArray(data?.items) || data?.items.length === 0) return "0.000";

    return data.items
      .reduce((total: any, item: any) => {
        const itemTotalHT =
          (item.article?.prix_vente_ht || 0) * (item.quantity || 0);
        return total + itemTotalHT;
      }, 0)
      .toFixed(3); // Keep three decimal places for precision
  };
  const [total, setTotal] = useState<any>(0);
  const getCalculatedTotals = () => {
    let reduction = 0;
    if (data?.bonReduction) {
      reduction = data?.bonReduction.amount;
    }
    if (!Array.isArray(data?.items)) {
      return { totalHT: 0, totalRemise: 0, totalTTC: 0, totalNetTTC: 0 };
    }

    const totals = data.items.reduce(
      (acc: any, item: any) => {
        const qty = Number(item.quantity) || 0;
        const priceHT = Number(item.article?.prix_vente_ht) || 0;
        const priceTTC = Number(item.article?.prix_vente_ttc) || 0;
        const remisePercent = Number(item.remise) || 0;

        // Line totals
        const lineHT = priceHT * qty;
        const lineTTC = priceTTC * qty;
        const lineRemise = (lineTTC * remisePercent) / 100;
        const lineNetTTC = lineTTC - lineRemise;

        return {
          totalHT: acc.totalHT + lineHT,
          totalRemise: acc.totalRemise + lineRemise,
          totalTTC: acc.totalTTC + lineTTC,
          totalNetTTC: acc.totalNetTTC + lineNetTTC,
        };
      },
      { totalHT: 0, totalRemise: 0, totalTTC: 0, totalNetTTC: 0 },
    );

    return {
      ...totals,
      totalHT: Math.max(0, totals.totalHT),
      totalTTC: Math.max(0, totals.totalTTC),
      totalNetTTC: Math.max(0, totals.totalNetTTC - reduction),
    };
  };

  const totals = getCalculatedTotals();

  // Exchange: returned products have a negative quantity, new products a positive one
  const returnedItems = Array.isArray(data?.items)
    ? data.items.filter((item: any) => Number(item.quantity) < 0)
    : [];
  const newItems = Array.isArray(data?.items)
    ? data.items.filter((item: any) => Number(item.quantity) >= 0)
    : [];
  const isExchange = returnedItems.length > 0 && newItems.length > 0;
  const sumLines = (items: any[]) =>
    items.reduce(
      (sum: number, item: any) => sum + Math.abs(Number(item.prixNet) || 0),
      0,
    );
  const totalReturned = sumLines(returnedItems);
  const totalNew = sumLines(newItems);
  // Bon de réduction of this exchange, read from the database
  const [bonEchange, setBonEchange] = useState<any>(null);
  useEffect(() => {
    setBonEchange(null);
    if (!isExchange || !data?._id) return;
    dispatch(getBonByEchangeOrder(data._id)).then((res: any) => {
      if (res.payload && res.payload._id) setBonEchange(res.payload);
    });
  }, [isExchange, data?._id]);

  // Difference from the database: the bon amount when the client got one,
  // otherwise the difference saved on the order (recomputed only for older exchanges)
  const exchangeDifference = bonEchange
    ? -Number(bonEchange.amount)
    : data?.differenceEchange !== undefined && data?.differenceEchange !== null
    ? Number(data.differenceEchange)
    : totalNew - totalReturned;

  const renderItemsTable = (items: any[]) => (
    <div className="table-responsive">
      <table className="table">
        <thead>
          <tr>
            <th scope="col">Réf</th>
            <th scope="col">Article</th>
            <th className="text-right" scope="col">
              Quantité
            </th>
            <th scope="col">Prix U. HT</th>
            <th scope="col">Taux TVA</th>
            <th className="text-right" scope="col">
              Prix U. TTC
            </th>
            <th className="text-right" scope="col">
              Remise
            </th>
            <th className="text-right" scope="col">
              Prix T. TTC
            </th>
          </tr>
        </thead>
        <tbody>
          {items.length > 0 ? (
            items.map((item: any, index: number) => (
              <tr key={`${item.article._id}-${index}`}>
                <td>{item.article?.code_article}</td>
                <td>{item.article.titre.fr}</td>
                <td className="text-right">
                  {isExchange ? Math.abs(item.quantity) : item.quantity}
                </td>
                <td className="text-right">
                  {(Number(item.article?.prix_vente_ht) || 0).toFixed(3)}
                </td>
                <td className="text-right">{item.article.tva}</td>
                <td className="text-right">
                  {(Number(item.article?.prix_vente_ttc) || 0).toFixed(3)}
                </td>
                <td className="text-right">{Number(item.remise) || 0}</td>
                <td className="text-right">
                  {(isExchange
                    ? Math.abs(Number(item.prixNet) || 0)
                    : Number(item.prixNet) || 0
                  ).toFixed(3)}
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan={8} className="text-center">
                Aucun article trouvé.
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );

  // 2. Update the useEffect for the "Final Total" (including shipping)
  useEffect(() => {
    const shouldApplyFees =
      order?.type === "online" && (order?.deliveryFees ?? true);

    const fraisLivraison = shouldApplyFees
      ? Number(livraison[0]?.frais_livraison) || 0
      : 0;

    const somme =
      type === "Echange" ? fraisLivraison : totals.totalNetTTC + fraisLivraison;

    setTotal(somme.toFixed(3));
  }, [data, livraison, type, totals.totalNetTTC]);

  return (
    <Modal size="xl" show={show} onHide={() => onClose()}>
      {loading ? ( // Show loader if loading
        <Loader />
      ) : order ? (
        <div className="row invoice layout-spacing">
          <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
            <div className="doc-container">
              <div className="invoice-container" ref={invoiceRef}>
                <div className="invoice-inbox">
                  <div className="invoice-00001">
                    <div className="content-section">
                      {/* Invoice Header */}
                      <div className="inv--head-section inv--detail-section">
                        <div className="row">
                          <div className="col-sm-6">
                            <div>
                              <h3 className="in-heading ml-0">{ste?.nom} </h3>
                              <p className="inv-client-name mb-0">
                                <strong>
                                  {"MF : " + ste?.matricule_fiscale}{" "}
                                </strong>
                              </p>
                              <p className="inv-client-name mb-0">
                                <strong>{ste?.tel} </strong>
                              </p>

                              <p className="inv-client-name">
                                <strong>{ste?.address} </strong>
                              </p>
                            </div>
                            {/* Client Info */}
                            <div>
                              <h3 className="in-heading ml-0">Facturé à :</h3>
                              <p className="inv-client-name mb-0">
                                <strong>Nom: </strong>
                                {order?.client_id?.nom ?? "N/A"}
                              </p>

                              <p className="inv-client-address mb-0">
                                <strong>Adresse: </strong>
                                {order?.client_id?.address ?? "N/A"}
                              </p>
                              <p className="inv-client-contact mb-0">
                                <strong>Contact: </strong>
                                {order?.client_id?.mobile ?? "N/A"}
                              </p>
                              {order?.client_id?.note && (
                                <p className="inv-client-contact mb-0">
                                  <strong>Note: </strong>
                                  {order?.client_id?.note ?? "N/A"}
                                </p>
                              )}
                            </div>
                          </div>

                          <div className="col-sm-6 text-sm-right">
                            {/* Order Details */}
                            <p className="inv-list-number">
                              <span
                                className="inv-title"
                                onClick={() => console.log(order)}
                              >
                                {ticketData && ticketData.process === "Echange"
                                  ? "Facture échange : "
                                  : "Facture : "}
                              </span>{" "}
                              <span className="inv-number">
                                {ticketData && ticketData.process === "Echange"
                                  ? ticketData.code
                                  : order?.order_number ?? "N/A"}
                              </span>
                            </p>

                            <p className="inv-created-date">
                              <span className="inv-title">Date: </span>{" "}
                              <span className="inv-date">
                                {order?.date?.toString().split("T")[0] ?? "N/A"}
                              </span>
                            </p>
                          </div>
                        </div>
                      </div>

                      <div className="inv--product-table-section">
                        {isExchange ? (
                          <>
                            <h5 className="mb-2">Articles retournés</h5>
                            {renderItemsTable(returnedItems)}
                            <h5 className="mb-2 mt-3">Nouveaux articles</h5>
                            {renderItemsTable(newItems)}
                          </>
                        ) : (
                          renderItemsTable(data?.items || [])
                        )}
                      </div>

                      {isExchange && (
                        <div className="row mb-3">
                          <div className="col-12 text-sm-right">
                            <h5 className="inv-total-title mb-1">
                              Total articles retournés :{" "}
                              {totalReturned.toFixed(3)} TND
                            </h5>
                            <h5 className="inv-total-title mb-1">
                              Total nouveaux articles : {totalNew.toFixed(3)}{" "}
                              TND
                            </h5>
                            <h5 className="inv-total-title mb-1">
                              Différence :{" "}
                              {exchangeDifference > 0
                                ? `${exchangeDifference.toFixed(3)} TND à payer`
                                : exchangeDifference < 0
                                ? `${Math.abs(exchangeDifference).toFixed(
                                    3,
                                  )} TND en faveur du client`
                                : "0.000 TND"}
                            </h5>
                            {bonEchange && (
                              <h5
                                className="inv-total-title mb-1"
                                style={{ color: "#009688", fontWeight: "bold" }}
                              >
                                Montant enregistré en bon de réduction :{" "}
                                {Number(bonEchange.amount).toFixed(3)} TND
                                {bonEchange.code
                                  ? ` (Code : ${bonEchange.code})`
                                  : ""}
                                {bonEchange.dateEcheance
                                  ? ` - valable jusqu'au ${
                                      bonEchange.dateEcheance
                                        .toString()
                                        .split("T")[0]
                                    }`
                                  : ""}
                              </h5>
                            )}
                          </div>
                        </div>
                      )}

                      <div className="row">
                        <h6 className="mb-0">
                          Arrêtée la présente facture à la somme de :{" "}
                          {numberToWords(total)}
                        </h6>
                      </div>

                      <div className="inv--total-amounts">
                        <div className="row mt-4">
                          <div className="col-sm-5 col-12 order-sm-0 order-1">
                            {Object.keys(paymentDetails || {}).length > 0 && (
                              <>
                                <h4 className="inv-total-title mb-2">
                                  Réglement(s)
                                </h4>
                                <table
                                  border={1}
                                  cellPadding="10"
                                  style={{
                                    borderCollapse: "collapse",
                                    width: "100%",
                                  }}
                                >
                                  <thead>
                                    <tr>
                                      <th>Méthode</th>
                                      <th>Montant</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {Object.entries(paymentDetails || {}).map(
                                      ([method, list]: any) => (
                                        <tr key={method}>
                                          <td>
                                            {method === "Cash"
                                              ? "Espéces"
                                              : method}
                                          </td>
                                          <td>
                                            {list
                                              .reduce(
                                                (s: number, p: any) =>
                                                  s + (Number(p.amount) || 0),
                                                0,
                                              )
                                              .toFixed(3)}{" "}
                                            TND
                                          </td>
                                        </tr>
                                      ),
                                    )}
                                    <tr>
                                      <td>
                                        <strong>Total payé</strong>
                                      </td>
                                      <td>
                                        <strong>
                                          {totalPaid.toFixed(3)} TND
                                        </strong>
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </>
                            )}
                          </div>
                          <div className="col-sm-7 col-12 order-sm-1 order-0 text-sm-right">
                            <div className="grand-total-amount">
                              <h4 className="inv-total">
                                Net à payer HT: {totals.totalHT.toFixed(3)} TND
                              </h4>
                            </div>

                            <div className="grand-total-amount">
                              <h4 className="inv-total">TVA: 19%</h4>
                            </div>

                            <div className="grand-total-title">
                              <h4 className="inv-total-title">
                                Total TTC Brut: {totals.totalTTC.toFixed(3)} TND
                              </h4>
                            </div>

                            <div className="grand-total-title">
                              <h4
                                className="inv-total-title"
                                style={{ color: "#e7515a" }}
                              >
                                Montant remise : -{" "}
                                {totals.totalRemise.toFixed(3)} TND
                              </h4>
                            </div>
                            {data?.bonReduction ? (
                              <div className="grand-total-title">
                                <h4
                                  className="inv-total-title"
                                  style={{ color: "#e7515a" }}
                                >
                                  Contre bon : -{" "}
                                  {data?.bonReduction.amount.toFixed(3)} TND
                                </h4>
                              </div>
                            ) : null}
                            <div className="grand-total-title">
                              <h4 className="inv-total-title">
                                Total Net TTC : {totals.totalNetTTC.toFixed(3)}{" "}
                                TND
                              </h4>
                            </div>

                            <div className="grand-total-amount">
                              <h4
                                className="inv-total"
                                style={{
                                  fontWeight: "bold",
                                  fontSize: "1.2rem",
                                }}
                              >
                                Net à payer TTC
                                {order?.type === "online" &&
                                (order?.deliveryFees ?? true)
                                  ? " (Livraison incluse)"
                                  : ""}
                                : {total} TND
                              </h4>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Submit Button */}
              <div className="row" style={{ justifyContent: "center" }}>
                <button
                  className="btn btn-success"
                  style={{ width: "50%" }}
                  onClick={handlePrint}
                >
                  {t("Imprimer")}
                </button>
              </div>
            </div>
          </div>
        </div>
      ) : null}
    </Modal>
  );
};

export default OnlineOrderInvoice;
